import RatingService from '_services/rest/modules/rating';

export default {
  state: {
    rating: null,
    answers: null,
    ratingList: null,
    questionsAndAnswers: null,
  },
  mutations: {
    setRating(state, response) {
      state.rating = response;
    },
    setRatingList(state, response) {
      state.ratingList = response;
    },
    setQuestionAndAnswers(state, response) {
      state.questionsAndAnswers = response;
    },
    setRatingAnswer(state, response) {
      state.answers = response;
    },
  },
  actions: {
    getAnswersList({ commit }, params) {
      RatingService.getAnswers(params)
        .then(response => {
          commit('setRatingAnswer', response);
        });
    },
    getRating({ commit }, params) {
      RatingService.getRating(params)
        .then(response => {
          commit('setRating', response);
        });
    },
    getRatingList({ commit }, params) {
      RatingService.getRatingList(params)
        .then(response => {
          commit('setRatingList', response);
        });
    },
    getUserAnswer({ commit }, params) {
      RatingService.getUserAnswer(params)
        .then(response => {
          commit('setQuestionAndAnswers', response);
        });
    },
    updateRating({ commit }, params) {
      RatingService.updateRating(params)
        .then(response => {
          commit('setRating', response);
        });
    },
  },
};
